import {
  deserify,
  IStyles,
  Loader,
  PrimaryButton,
  pxToRem,
  pxTovW,
  theme,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import { Typography, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';

import { ChapterSelection } from './components/ChapterSelection';
import { AddSection } from './components/AddSection';
import { Settings } from './components/Settings';
import {
  ASSESSMENT_REVIEW,
  HOME,
  HOMEWORK_MANAGE,
  QPG,
} from '../../../../routeHandling/RoutesNomenclature';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../reduxStore/reduxHooks';
import {
  resetAssessmentFlowState,
  setCurrentQPGTemplateInfo,
  setQPGGeneratedTemplates,
  setQPGSettingsConfig,
} from '../../reducer/assessmentFlow.slice';
import { StepperComponent } from './components/Stepper';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Module_ModuleCategoryEnum } from '@protos/content_management/content.db_pb';
import {
  ChapterIdsInfo,
  TaskCreationStatusEnum,
  TaskEnum,
  TopicIdsInfo,
} from '@protos/learning_management/lms.db_pb';
import { TopicBasicInfo } from '@protos/content_management/content.common.apis_pb';
import { getDifficultyLevelFromString } from '../../Common/ReviewAssessment/functions';
import { AssessmentCreationEnum } from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import { EditWarningPopup } from 'apps/teacher/src/components/EditWarningPopup';
import { useGlobalContext } from 'apps/teacher/src/app/Context/GlobalContextProvider';
import { CreateAssessmentPopup } from './components/CreateAssessmentPopup';
import { ConnectError } from '@bufbuild/connect';
import { setToastInfo } from '../../../Home/reducer/homeDashboard.slice';
import { interactionEvent } from '../../../Auth/auth.events';
import { useDownloadContext } from '../../../../app/Context/DownloadContextProviderV2';

const styles: IStyles = {
  root: {
    boxSizing: 'border-box',
    width: { xs: '100%', md: '100%' },
    overflowX: 'hidden',
    paddingX: { xs: pxToRem(20), md: pxTovW(50), lg: pxTovW(240) },
    paddingBottom: { xs: pxToRem(90), md: pxTovW(40) },
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    // height: { md: '100vh' },
    alignItems: 'center',
    // maxHeight: {
    //   xs: `calc(100vh - ${pxToRem(60)})`,
    //   md: `none`,
    // },
    overflowY: 'auto',
  },
  buttonContainer: {
    position: { xs: 'fixed', md: 'unset' },
    top: { xs: '91%' },
    width: { xs: '90%', md: pxTovW(397) },
    height: { xs: pxToRem(50), md: pxTovW(80), lg: pxTovW(60) },
    marginLeft: 'auto',
    zIndex: { xs: 1, md: 0 },
  },
};

interface ISteps {
  index: number;
  stepTitle: string;
  stepClickHandler: () => void;
  nextClickHandler?: () => void;
  stepButtonText?: string;
  disableStep: boolean;
  stepIconColor: string;
  disabledIconColor?: string;
  element?: JSX.Element;
}
export const QuestionPaperCreate = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { subject_id } = useParams();
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();

  const [editPopupOpen, setEditPopupOpen] = useState(false);
  const [logoClick, setLogoClick] = useState(false);
  const { setSelectedFunction, setSelectedLogoClickHandler } =
    useGlobalContext();
  const backButtonClick = async () => {
    setEditPopupOpen(true);
  };
  const handleLogoClick = () => {
    setLogoClick(true);
    setEditPopupOpen(true);
  };
  useEffect(() => {
    setSelectedFunction(() => backButtonClick);
    setSelectedLogoClickHandler(() => handleLogoClick);
    return () => {
      setSelectedFunction(() => null);
      setSelectedLogoClickHandler(() => null);
    };
  }, []);
  const {
    qpg_selected_chapter_data,
    qpg_settings_config,
    current_qpg_template_info,
  } = deserify(useAppSelector((state) => state.assessment));
  const [loading, setLoading] = useState<'loading' | 'success' | 'error'>(
    'success'
  );
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const [selectedStepIndex, setSelectedStepIndex] = useState<number>(0);
  const [assessmentName, setAssessmentName] = useState<string>('');
  const [createAssessmentPopupOpen, setCreateAssessmentPopupOpen] =
    useState(false);
  const { class_subject_info } = deserify(
    useAppSelector((state) => state.homeDashboard)
  );

  const {
    LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV8WithStatusCodeHandler,
  } = useCommonServiceClientContext();
  const [isTemplatevalid, setIsTemplateValid] = useState<boolean>(false);

  useEffect(() => {
    setSelectedStepIndex(0);
  }, []);

  // useEffect(() => {
  //   if (
  //     current_qpg_template_info?.questionSectionInfo &&
  //     current_qpg_template_info?.questionSectionInfo.length > 0
  //   ) {
  //     if (
  //       current_qpg_template_info?.questionSectionInfo.every(
  //         (e) => e.noOfQuestion > 0
  //       )
  //     ) {
  //       setIsTemplateValid(true);
  //     } else {
  //       setIsTemplateValid(false);
  //     }
  //   } else {
  //     setIsTemplateValid(false);
  //   }
  // }, [current_qpg_template_info?.questionSectionInfo]);

  const steps: ISteps[] = [
    {
      index: 0,
      stepTitle: 'Chapter Selection',
      stepClickHandler: async () => {
        dispatch(setQPGSettingsConfig(undefined));
        dispatch(setCurrentQPGTemplateInfo(undefined));
        dispatch(setQPGGeneratedTemplates(undefined));
        setSelectedStepIndex(0);
        console.log('Step 1 Clicked');
        await interactionEvent({
          context: 'Question_paper_generator',
          name: 'CHAPTER_SELECTION',
          pathSegments: pathSegments,
          isOffline: isOffline,
        });
      },
      stepButtonText: 'NEXT',
      disableStep: false,
      stepIconColor: '#007CDC',
      disabledIconColor: '#7EC6FD',
      element: <ChapterSelection />,
    },

    {
      index: 1,
      stepTitle: 'Settings',
      stepClickHandler: async () => {
        dispatch(setCurrentQPGTemplateInfo(undefined));
        dispatch(setQPGGeneratedTemplates(undefined));
        setSelectedStepIndex(1);
        console.log('Step 2 Clicked');
        await interactionEvent({
          context: 'Question_paper_generator',
          name: 'SETTINGS',
          pathSegments: pathSegments,
          isOffline: isOffline,
        });
      },
      stepButtonText: 'NEXT',
      disableStep:
        !qpg_selected_chapter_data?.chapters ||
        qpg_selected_chapter_data?.chapters?.length === 0,
      stepIconColor: '#0AA34F',
      disabledIconColor: '#44FD97',
      element: isNaN(Number(subject_id)) ? (
        <></>
      ) : (
        <Settings subjectId={Number(subject_id)} />
      ),
    },
    {
      index: 2,
      stepTitle: 'Add Section',
      stepClickHandler: async () => {
        setSelectedStepIndex(2);
        await interactionEvent({
          context: 'Question_paper_generator',
          name: 'ADD_SECTION',
          pathSegments: pathSegments,
          isOffline: isOffline,
        });
      },
      stepButtonText: 'CREATE TEST',
      disableStep:
        qpg_settings_config == undefined ||
        (Object.values(
          qpg_settings_config?.no_ofQuestions_by_types || {}
        ).reduce((acc, curr) => acc + (curr || 0), 0) === 0 &&
          !qpg_settings_config.allow_ai_questions) ||
        (current_qpg_template_info?.questionSectionInfo?.some(
          (section) => section.marks === 0
        ) ??
          false),
      // if no questions available in db and AI is disabled then disable the step
      // also disable if any section has marks as 0
      stepIconColor: '#F8C807',
      disabledIconColor: '#FEEDAE',
      element: (
        <AddSection
          isTemplateValid={isTemplatevalid}
          setIsTemplateValid={setIsTemplateValid}
          subjectId={Number(subject_id)}
        />
      ),
    },
  ];

  const handleCreateTest = async () => {
    try {
      setLoading('loading');
      const moduleQuestions =
        await LmsAssessmentTeacherAPIServiceV8WithStatusCodeHandler.getModuleQuestionsWithFilters(
          {
            teacherId: user_info?.teacherProfileId,
            subjectId: class_subject_info?.subjectId,
            moduleIds:
              qpg_selected_chapter_data?.chapters
                .flatMap((chapter) => [
                  chapter.chapterId,
                  ...chapter.topics.map((topic) => topic.topicId),
                ])
                ?.sort((a, b) => a - b) || [],
            bloomLevels: qpg_settings_config?.bloomLevels || [],
            avgDifficultyLevel: getDifficultyLevelFromString(
              qpg_settings_config?.overallDifficultyLevel || 'Medium'
            ),
            assessmentCreationType:
              AssessmentCreationEnum.ASSESSMENT_CREATION_QUESTION_PAPER,
            questionSectionInfo: current_qpg_template_info?.questionSectionInfo,
            allowAiQuestions: !!qpg_settings_config?.allow_ai_questions,
            isAiAssessment: !!qpg_settings_config?.allow_ai_questions,
            aiQuestionPrompts:
              qpg_settings_config?.prompt &&
              qpg_settings_config?.allow_ai_questions
                ? [qpg_settings_config.prompt]
                : [],
          }
        );
      const questionSectionMetaInfo = (
        moduleQuestions.data?.questionSectionMetaInfo || []
      ).filter(
        (info) =>
          info.sectionQuestionsInfo.length > 0 &&
          info.sectionQuestionsInfo.some(
            (ques) =>
              ques.questionId !== undefined ||
              (Array.isArray(ques.alternateQuestions) &&
                ques.alternateQuestions?.length > 0)
          )
      );
      const assessmentCreationSubmitResponse =
        await LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler.assessmentCreationSubmit(
          {
            teacherId: user_info?.teacherProfileId,
            subjectId: class_subject_info?.subjectId,
            sectionId: class_subject_info?.sectionId,
            taskName: assessmentName,
            isAiAssessment: qpg_settings_config?.allow_ai_questions,
            category: Module_ModuleCategoryEnum.MODULE_CATEGORY_BOOK,
            instructions: [],
            creationStatus: TaskCreationStatusEnum.TASK_CREATION_STATUS_DRAFT,
            taskType: TaskEnum.TASK_QUESTION_PAPER_CUSTOM,
            questionModuleMap: moduleQuestions.data?.questionModuleMap,
            questionTypeAndMarks:
              qpg_settings_config?.question_type_marks || [],
            chapterIdsInfo: qpg_selected_chapter_data?.chapters.map(
              (chapter) => {
                return new ChapterIdsInfo({
                  chapterId: chapter.chapterId,
                  name: chapter.chapterTitle,
                  chapterNo: chapter.chapterNo,
                  topicInfo: chapter.topics.map((topic) => {
                    return new TopicIdsInfo({
                      topicId: topic.topicId,
                      name: topic.topicTitle,
                      topicNo: topic.topicNo,
                    });
                  }),
                });
              }
            ),
            questionSectionMetaInfo: questionSectionMetaInfo,
          }
        );
      if (assessmentCreationSubmitResponse.data?.assessment?.assessmentId) {
        navigate(
          `${QPG}${ASSESSMENT_REVIEW}/${assessmentCreationSubmitResponse.data?.assessment?.assessmentId}`,
          {
            state: {
              redirectionPath: location.state?.redirectionPath,
            },
          }
        );
      }
    } catch (error) {
      let message = 'Error while creating assessment';
      if (error instanceof ConnectError) {
        message = error.rawMessage?.replace(/.*\]\s*/, '').trim();
      }
      setLoading('error');
      dispatch(
        setToastInfo({
          label: message,
          variant: 'error',
          open: true,
        })
      );
      console.log(error);
    } finally {
      setLoading('success');
    }
  };
  const handleNextClick = async () => {
    if (selectedStepIndex === steps.length - 1) {
      setCreateAssessmentPopupOpen(true);
    } else {
      setSelectedStepIndex(selectedStepIndex + 1);
    }
    await interactionEvent({
      context: 'Question_paper_generator',
      name: (steps[selectedStepIndex]?.stepButtonText || 'NEXT')
        .toUpperCase()
        .replace(/\s+/g, '_'),
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };

  if (loading === 'loading') return <Loader />;
  return (
    <Box sx={styles.root}>
      <Box
        sx={{
          width: '100%',
          justifyContent: 'space-between',
          // alignItems: 'center',
          marginY: { xs: pxToRem(23), md: pxTovW(41) },
          display: 'flex',
        }}
      >
        <Typography variant="h1">Question Paper Generator</Typography>

        <PrimaryButton
          sx={styles.buttonContainer}
          disabled={
            selectedStepIndex === steps.length - 1
              ? !current_qpg_template_info?.questionSectionInfo ||
                !!(
                  (
                    qpg_settings_config?.allow_ai_questions &&
                    qpg_settings_config?.prompt && // if prompt is there
                    (!qpg_settings_config?.prompt_validated || // not validated then disable
                      qpg_settings_config?.prompt_validated === 'error')
                  ) // invalid prompt
                ) ||
                current_qpg_template_info?.questionSectionInfo?.reduce(
                  (acc, curr) => acc + (curr?.noOfQuestion || 0),
                  0
                ) === 0 ||
                !isTemplatevalid ||
                (current_qpg_template_info?.questionSectionInfo?.some(
                  (section) => section.marks === 0
                ) ??
                  false)
              : steps[selectedStepIndex + 1]?.disableStep
          }
          onClick={handleNextClick}
        >
          <Typography
            variant={isMobile ? 'h2' : 'h3'}
            color={'common.white'}
            fontWeight={'bold'}
          >
            {steps[selectedStepIndex]?.stepButtonText || 'Next'}
          </Typography>
        </PrimaryButton>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: { xs: '100%', md: pxTovW(419), mb: pxTovW(40) },
          mb: { xs: pxToRem(40), md: pxTovW(20) },
        }}
      >
        <StepperComponent currentStep={selectedStepIndex} steps={steps} />
      </Box>

      <Box
        sx={{ width: '100%', justifyContent: 'center', alignItems: 'center' }}
      >
        {steps[selectedStepIndex]?.element}
      </Box>

      <EditWarningPopup
        open={editPopupOpen}
        handleClose={() => {
          if (logoClick) {
            setLogoClick(false);
            setSelectedLogoClickHandler(() => handleLogoClick);
          } else {
            setSelectedFunction(() => backButtonClick);
          }
          setEditPopupOpen(false);
        }}
        yesClickHandler={() => {
          if (logoClick) {
            dispatch(resetAssessmentFlowState());
            navigate(HOME);
            return;
          }
          navigate(HOMEWORK_MANAGE);
        }}
        noClickHandler={() => {
          if (logoClick) {
            setLogoClick(false);
            setSelectedLogoClickHandler(() => handleLogoClick);
          } else {
            setSelectedFunction(() => backButtonClick);
          }
          setEditPopupOpen(false);
        }}
        iconname="back"
        text1="If you go back, you may lose your changes."
        text2="Are you sure you want go back?"
      />

      <CreateAssessmentPopup
        open={createAssessmentPopupOpen}
        handleClose={() => {
          setAssessmentName('');
          setCreateAssessmentPopupOpen(false);
        }}
        createAssessmentHandler={handleCreateTest}
        assessmentName={assessmentName}
        setAssessmentName={setAssessmentName}
      />
    </Box>
  );
};
